var escape = require("../../css-loader/lib/url/escape.js");
exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:Roboto;font-style:normal;font-weight:100;src:url(" + escape(require("./web-font/KFOkCnqEu92Fr1MmgVxIIzQ.woff")) + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:normal;font-weight:300;src:url(" + escape(require("./web-font/KFOlCnqEu92Fr1MmSU5fBBc-.woff")) + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:normal;font-weight:400;src:url(" + escape(require("./web-font/KFOmCnqEu92Fr1Mu4mxM.woff")) + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:normal;font-weight:500;src:url(" + escape(require("./web-font/KFOlCnqEu92Fr1MmEU9fBBc-.woff")) + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:normal;font-weight:700;src:url(" + escape(require("./web-font/KFOlCnqEu92Fr1MmWUlfBBc-.woff")) + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:normal;font-weight:900;src:url(" + escape(require("./web-font/KFOlCnqEu92Fr1MmYUtfBBc-.woff")) + ") format(\"woff\")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/quasar-extras/roboto-font/roboto-font.css
// module id = lkaK
// module chunks = 49